import { render, staticRenderFns } from "./NTOAldi.vue?vue&type=template&id=ed76789e&"
import script from "./NTOAldi.vue?vue&type=script&lang=js&"
export * from "./NTOAldi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports